import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.split('/')[2] || '';

  return (
    <div className="flex items-center gap-1 p-1 bg-background-100 rounded-full">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
            currentSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}